import React from "react";
import MainContent from "../components/HomePage/MainContent";
import ClientSpotlight from "../components/HomePage/ClientSpotlight";
import DeeperInsights from "../components/HomePage/DeeperInsights";
import DepartmentCards from "../components/HomePage/DepartmentCards";
import SupportCards from "../components/HomePage/SupportCards";
import ProblemSolution from "../components/HomePage/ProblemSolution";
import Solutions from "../components/HomePage/Solutions";
import TechnologyPartnersSection from "../components/TechnologyPartnersSection";

const HomePage = ({ departmentsRef, solutionsRef, resourcesRef, aboutRef }) => {
  return (
    <>
      <MainContent />
      <ClientSpotlight />
      <Solutions solutionsRef={solutionsRef} />
      <DeeperInsights/>
      <DepartmentCards departmentsRef={departmentsRef} /> 
      <ProblemSolution/>
      <TechnologyPartnersSection/>
      <SupportCards/>
    </>
  );
};

export default HomePage;
